import { NoddiIcon } from 'noddi-ui-common';
import { NoddiInput } from 'noddi-ui-web';

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
};

export const PickerSearch = ({ value, onChange, placeholder }: Props) => (
  <div className='sticky top-0 z-10 -mx-4 bg-background px-4 pb-2'>
    <NoddiInput
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      startAdornment={<NoddiIcon name='Search' size='small' className='text-muted-foreground' />}
    />
  </div>
);
